import { apiSlice } from "../../app/api/apiSlice";

export const fetchEnhancedConditionAttachmentsPendingRetryApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		enhancedConditionAttachmentsPendingRetry: builder.mutation({
			query: (credentials) => ({
				url: `api/v1/loan/get_enhanced_condition_attachments_pending_retry/${credentials.loanGuid}/`,
				method: "GET",
			}),
		}),
	}),
});

export const { useEnhancedConditionAttachmentsPendingRetryMutation } =
	fetchEnhancedConditionAttachmentsPendingRetryApiSlice;
